import React from 'react'
import { Card, CardActions, CardTitle, CardText } from 'material-ui-legacy/Card'

import { niceJoin } from '../../lib/formats'
import DeleteButton from '../UI/DeleteButton'
import EditButton from '../UI/EditButton'
import CloseButton from '../UI/CloseButton'

const ClientCard = props => {
  // Data can be received either as client or itemData.
  const client = props.client || props.itemData

  return (
    <Card>
      <CardTitle
        title={client.attributes.name}
        subtitle={niceJoin([
          client.attributes.city,
          client.attributes.province,
          client.attributes.country
        ])}
      />

      <CardText>
        {client.attributes.phone && (
          <p>
            <strong>Phone:</strong> {client.attributes.phone}
          </p>
        )}
        {client.attributes.address && (
          <p>
            <strong>Address:</strong> {client.attributes.address}
          </p>
        )}
        {client.attributes.city && (
          <p>
            <strong>City:</strong> {client.attributes.city}
          </p>
        )}
        {client.attributes.province && (
          <p>
            <strong>State/Province:</strong> {client.attributes.province}
          </p>
        )}
        {client.attributes.country && (
          <p>
            <strong>Country:</strong> {client.attributes.country}
          </p>
        )}
        {client.attributes.postalCode && (
          <p>
            <strong>Postal code:</strong> {client.attributes.postalCode}
          </p>
        )}
        {client.attributes.code && (
          <p>
            <strong>Legacy code:</strong> {client.attributes.code}
          </p>
        )}
      </CardText>

      <CardActions>
        {props.editCallback && <EditButton onTouchTap={props.editCallback} />}
        {props.deleteCallback && (
          <DeleteButton
            onTouchTap={props.deleteCallback}
            confirmMessage={
              <p>
                Are you sure you want to delete{' '}
                <strong>{client.attributes.name}</strong>? There's no undo.
              </p>
            }
          />
        )}
        {props.closeCallback && (
          <CloseButton onTouchTap={props.closeCallback} />
        )}
      </CardActions>
    </Card>
  )
}

export default ClientCard



// WEBPACK FOOTER //
// ./src/components/Clients/ClientCard.jsx